import {
  FareInfo,
  FareInfoTravelDocument,
} from '@dapi/sdk';
import {
  arnEwrFlight,
  cphOslFlightItem,
  helTkuFlight,
  tkuHelFlight,
} from './flights';
import {
  traveler,
} from './traveler';

export const fareInfo: FareInfo = {
  fareType: 'public',
  fareClass: 'YIFE',
  travelerIds: [traveler.id],
  flightIds: [cphOslFlightItem.id]
};

export const arnEwhFareInfo: FareInfoTravelDocument[] = [{
  fareClass: 'YSEOW/CH',
  couponStatus: 'open',
  flight: arnEwrFlight,
  freeCheckedBaggageAllowanceItems: [{
    details: {
      type: 'piece',
      quantity: 1
    }
  }]
}];

export const fareInfoRoundTrip: FareInfoTravelDocument[] = [{
  fareClass: 'YPR0FI',
  fareFamilyCode: 'PRO',
  couponStatus: 'open',
  flight: helTkuFlight
},
{
  fareClass: 'YPR0FI',
  fareFamilyCode: 'PRO',
  couponStatus: 'open',
  flight: tkuHelFlight
}];
